import { Component, EventEmitter, Input, Output, LOCALE_ID, Inject } from '@angular/core'
import { ProductReleases } from '../models/productreleases';
import { AdminService } from '../admin/admin.service';
import { DatePipe } from '../../../node_modules/@angular/common';
import { NumberConstants } from "../common/numberconstants";
import { TranslateService } from '@ngx-translate/core';
import { EnvironmentsService } from 'app/services/enviornment.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'manage-release-modal',
  templateUrl: './manage-release-modal.component.html',
  styleUrls: ['./manage-release-modal.component.scss']
})
export class ManageReleaseModalComponent {
  @Input() releaseModal: any = {};
  @Input() vmwareProductId: number = 0;
  @Input() releaseModalData: ProductReleases;
  @Output() onBtnSelection = new EventEmitter<ProductReleases>();
  private isFromRM: boolean = false;
  rmReleases: Array<ProductReleases>;
  rmReleaseError: string = this.translateService.instant('admin.releaseMasterMsg');
  rmProductId = this.numberconstants.MINUS_ONE;
  locale: string = "";
  selectedAddOpt: number = this.numberconstants.TWO;
  rmGADate: string = "1420070400000"; /* EPOCH Date for 01/012015 */
  alertType: string = "alert-info";
  langSub: Subscription;

  radioOptions = [
    {
      "id": this.numberconstants.ONE,
      "value": this.translateService.instant('createFromRm'),
      "isChecked": false,
      "isdisabled": false
    },
    {
      "id": this.numberconstants.TWO,
      "value": this.translateService.instant('admin.addNewCreateInConfigmax'),
      "isChecked": true,
      "isdisabled": false
    }
  ];
  constructor(private adminService: AdminService, @Inject(LOCALE_ID) _locale: string,private numberconstants: NumberConstants,private translateService: TranslateService, private envService: EnvironmentsService) {
    this.locale = _locale;
  }
  modalHandler(btnOutput: boolean) {
    this.releaseModal.state = false;
    this.resetModal();
    if (!btnOutput) {
      this.releaseModalData = undefined;
    }
    this.onBtnSelection.emit(this.releaseModalData);
  }

  resetModal() {
    this.radioOptions[this.numberconstants.ONE].isChecked = true;
    this.radioOptions[this.numberconstants.ZERO].isChecked = false;
    this.isFromRM = false;
    this.selectedAddOpt = this.numberconstants.TWO;
    this.rmGADate = "1420070400000";
    this.alertType = "alert-info";
    this.rmReleaseError = this.translateService.instant('admin.releaseMasterMsg');
  }

  onAddOptionSelection(option) {
    if (option.value === this.translateService.instant('createFromRm')) {
      this.alertType = "alert-info";
      this.isFromRM = true;
      this.getRMReleases(this.vmwareProductId);
    } else {
      this.isFromRM = false;
      this.releaseModalData = new ProductReleases();
    }
  }

  loadRMReleases(e) {
    let productId = parseInt(e.target['value'], this.numberconstants.TEN);
    if (productId !== this.numberconstants.MINUS_ONE) {
      this.releaseModalData = JSON.parse(JSON.stringify(this.rmReleases[productId]));
      this.releaseModalData.rmVmwPrdRelVersion = this.rmReleases[productId].rmVmwPrdRelVersion;
      this.releaseModalData.rmVmwPrdRelGADate = new DatePipe(this.locale).transform(
        this.rmReleases[productId].rmVmwPrdRelGADate, 'yyyy-MM-dd');
      this.releaseModalData.cmRelPublishDate = new DatePipe(this.locale).transform(
        this.rmReleases[productId].cmRelPublishDate, 'yyyy-MM-dd');
      this.releaseModalData["support"] = this.rmReleases[productId]["support"];
      this.releaseModalData["decription"] = this.rmReleases[productId]["decription"];
    }
  }

  getRMReleases(vmwareProductId): void {
    this.rmReleases = undefined;
    this.rmProductId = this.numberconstants.MINUS_ONE ;
    this.alertType = "alert-info";
    this.rmReleaseError = this.translateService.instant('admin.releaseMasterMsg');
    this.adminService.getRMReleasesNotInConfigMax(vmwareProductId, new DatePipe(this.locale).transform(
      this.rmGADate, 'yyyy-MM-dd'))
      .subscribe(
        rmReleases => {
          if (!rmReleases || rmReleases.length === this.numberconstants.ZERO) {
            this.rmReleaseError = this.translateService.instant('rmRelNotAvailable');
            this.alertType = "alert-danger";
            this.rmReleases = undefined;
          } else {
            this.rmReleases = rmReleases;
          }
          this.alertType = "";
        },
        err => {
          console.log(err);
          this.alertType = "alert-danger";
          this.rmReleaseError = this.translateService.instant('unableToFetchRm');
          this.rmReleases = undefined;
        });
  }
  ngOnInit(){
    this.langSub = this.envService.selectedLanguage$.subscribe((lang)=>{
      // this.translateService.use(lang);
      this.rmReleaseError = this.translateService.instant('admin.releaseMasterMsg');
      this.radioOptions[0].value =  this.translateService.instant('createFromRm');
      this.radioOptions[1].value = this.translateService.instant('admin.addNewCreateInConfigmax');
      this.rmReleaseError = this.translateService.instant('admin.releaseMasterMsg');
      this.rmReleaseError = this.translateService.instant('unableToFetchRm');
      this.rmReleaseError = this.translateService.instant('rmRelNotAvailable');
  });
}
}



// WEBPACK FOOTER //
// ./src/app/manage-release-modal/manage-release-modal.component.ts